import { render, staticRenderFns } from "./ThirdPartyPayment.vue?vue&type=template&id=2d5bdc76&scoped=true"
import script from "./ThirdPartyPayment.vue?vue&type=script&lang=js"
export * from "./ThirdPartyPayment.vue?vue&type=script&lang=js"
import style0 from "./ThirdPartyPayment.vue?vue&type=style&index=0&id=2d5bdc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5bdc76",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme2DesktopWithdrawStep: require('/app/components/Theme2/Desktop/WithdrawStep.vue').default,CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default,Theme2DesktopBankAccountCard: require('/app/components/Theme2/Desktop/BankAccountCard.vue').default})
